/**
 * Очередь прозвона и назначения.
 *
 * Одна строка очереди — контакт на одном круге. Круг 1 — свежий контакт,
 * дальше недозвон: он закреплён за диспетчером, который звонил.
 *
 * Значения перечислений повторяют типы базы (§5.4) буква в букву:
 * расхождение здесь означает статус, которого в базе не существует.
 */
/** Состояния элемента очереди (§5.4) */
export const QUEUE_STATUSES = [
    /** Ждёт раздачи */
    'new',
    /** Выдан диспетчеру */
    'assigned',
    /** Круги исчерпаны, отдан роботу */
    'robot',
    /** Отработан */
    'done',
    /** Снят из прозвона: отказ, чёрный список, решение админа */
    'excluded',
];
/** Состояния назначения (§5.4) */
export const ASSIGNMENT_STATUSES = [
    /** Выдано, диспетчер ещё не звонил */
    'open',
    /** Звонок состоялся, метки пока нет */
    'called',
    /** Разговор закончился, метку ждут от диспетчера */
    'needs_label',
    /** Метка поставлена, назначение закрыто */
    'labeled',
    /** Диспетчер не успел до конца смены, контакт вернулся в очередь */
    'expired',
    /** Отозвано админом */
    'revoked',
];
/** Первый круг — свежий контакт, всё остальное — недозвон */
export function isRedial(roundNumber) {
    return roundNumber > 1;
}
//# sourceMappingURL=queue.js.map